export function chunkArray<T>(arr: T[], size: number): T[][] {
  const chuncks = [];
  // eslint-disable-next-line fp/no-loops
  for (let i = 0; i < arr.length; i += size) {
    // eslint-disable-next-line
    chuncks.push(arr.slice(i, i + size));
  }

  return chuncks;
}
